import Plyr from "plyr";
import {
  checkUcInit,
  getUcService,
  acceptUcService,
} from "../modules/usercentrics.module";

// const base = window.location.href.split("?")[0];
const vData = {
  status: {},
  youtube: {
    id: "BJz7qNsdj-7",
    consent: false,
  },
  vimeo: {
    id: "",
    consent: false,
  },
  plyrOptions: {
    iconUrl: "/typo3conf/ext/as_template/Resources/Public/Vendor/plyr/plyr.svg",
    blankVideo:
      "/typo3conf/ext/as_template/Resources/Public/Vendor/plyr/blank.mp4",
    youtube: { noCookie: true },
    controls: [
      "play-large",
      "play",
      "progress",
      "current-time",
      "mute",
      "volume",
      "captions",
      "settings",
      "airplay",
      "fullscreen",
    ],
  },
  baseDataLayer: {
    event: "gtmEvent",
    event_name: "video_interaction",
    event_category: "HTML5 Video",
  },
};

const checkConsent = () => {
  if (checkUcInit()) {
    if (getUcService("BJz7qNsdj-7")) {
      document.body.classList.remove("noYoutube");
      vData.youtube.consent = true;
    } else {
      document.body.classList.add("noYoutube");
      vData.youtube.consent = false;
    }
  }
};

const getVideoName = (plyr) => {
  let videoName = plyr.elements.original.dataset.plyrEmbedId;
  if (plyr.provider === "html5") {
    let name = plyr.elements.original.currentSrc;
    if (name.includes("mediapool")) {
      let a1 = name.split("mediapool");
      videoName = a1[1];
    } else if (name.includes("fileadmin")) {
      let a2 = name.split("fileadmin");
      videoName = a2[1];
    }
  }
  return videoName;
};

const timeupdate = (e, id) => {
  let currentTime = e.detail.plyr.media.currentTime;
  let duration = e.detail.plyr.media.duration;
  let videoName = getVideoName(e.detail.plyr);

  vData.status[id].current = Math.round(currentTime);
  let pct = Math.floor((100 * currentTime) / duration);

  // console.log(vData.status[id]._progress_markers);

  for (let j in vData.status[id]._progress_markers) {
    if (
      pct >= parseInt(j) &&
      parseInt(j) >= parseInt(vData.status[id].greatest_marker)
    ) {
      vData.status[id].greatest_marker = j;
    }
  }

  if (typeof dataLayer !== undefined) {
    if (
      vData.status[id].greatest_marker &&
      !vData.status[id]._progress_markers[vData.status[id].greatest_marker]
    ) {
      vData.status[id]._progress_markers[
        vData.status[id].greatest_marker
      ] = true;
      dataLayer.push({
        ...vData.baseDataLayer,
        event_action: "Played video",
        video_name: videoName,
        video_progress: vData.status[id].greatest_marker / 100,
      });
    }
  }
  // console.log("timeupdate", dataLayer);
};

const playUpdate = (e, id) => {
  let videoName = getVideoName(e.detail.plyr);
  dataLayer.push({
    ...vData.baseDataLayer,
    event_action: "Play video",
    video_name: videoName,
  });
  // console.log("playUpdate", dataLayer);
};

const pauseUpdate = (e, id) => {
  let videoName = getVideoName(e.detail.plyr);
  dataLayer.push({
    ...vData.baseDataLayer,
    event_action: "Pause video",
    video_name: videoName,
  });
  // console.log("pauseUpdate", dataLayer);
};

const seekedUpdate = (e, cTime) => {
  let videoName = getVideoName(e.detail.plyr);
  dataLayer.push({
    ...vData.baseDataLayer,
    event_action: "Seek video",
    video_seek: cTime,
    video_name: videoName,
  });
  // console.log("seekedUpdate", dataLayer);
};

export const video = (id) => {
  let player = null;
  let local = false;
  let plyr = true;
  let videoTagId = `${id}_html5_api`;
  let videoEl = document.querySelector(`#${id}`);
  let videoBox = videoEl.closest(".video-box");
  let videoBtn = videoBox.querySelector(".video-play-button");
  let ucNotice = videoBox.querySelector(".uc-notice");
  let ucNoticeBtn = videoBox.querySelector(".uc-notice .btn.primary");

  let init = () => {
    player = new Plyr(`#${id}`, vData.plyrOptions);

    vData.status[videoTagId] = {};
    vData.status[videoTagId].greatest_marker = 0;
    vData.status[videoTagId]._progress_markers = {};

    // part progress in 25% steps
    for (let j = 0; j <= 100; j++) {
      vData.status[videoTagId].progress_point = 25 * Math.floor(j / 25);
      vData.status[videoTagId]._progress_markers[
        vData.status[videoTagId].progress_point
      ] = false;
    }
    vData.status[videoTagId].current = 0;

    player.on("ready", (e) => {
      player.on("timeupdate", (e) => timeupdate(e, videoTagId));
      player.on("playing", (e) => videoBox.classList.add("playing"));
      player.on("seeked", (e) => seekedUpdate(e, player.currentTime));
      player.on("ended", () => videoBox.classList.remove("playing"));

      player.on("play", (e) => {
        playUpdate(e, videoTagId);
        videoBox.classList.add("playing");
      });

      player.on("pause", (e) => {
        pauseUpdate(e, videoTagId);
        if (player.seeking === false) {
          videoBox.classList.remove("playing");
        }
      });

      player.play();
    });

    videoBox.classList.add("init");
  };
  let play = () => player.play();

  // ============================================================
  // ============================================================

  checkConsent();

  if (videoEl.classList.contains("local")) local = true;
  if (videoEl.classList.contains("js-player")) plyr = false;

  if (local) {
    player ? play() : init();
  } else {
    if (!vData.youtube.consent && !vData.vimeo.consent) {
      ucNotice.classList.add("active");
    } else {
      ucNotice.classList.remove("active");
      player ? play() : init();
    }
  }

  if (ucNoticeBtn) {
    ucNoticeBtn.addEventListener("click", () => {
      videoBtn.classList.add("loading");
      acceptUcService("BJz7qNsdj-7");
      checkConsent();

      setTimeout(() => {
        checkConsent();
        if (vData.youtube.consent || vData.vimeo.consent) {
          player ? play() : init();
          ucNotice.classList.remove("active");
        }
      }, 500);
    });
  }

  $(document).on("asuc-updated", () => checkConsent());

  videoBtn.classList.add("loading");
  videoBtn.addEventListener("click", () => (player ? play() : init()));
};
